var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLeftRoundedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.502l-4.334-4.334a1.73 1.73 0 01-.375-.541 1.57 1.57 0 01-.125-.625c0-.223.042-.43.125-.625a1.73 1.73 0 01.375-.542l4.333-4.333c.528-.528 1.132-.646 1.812-.354.681.292 1.022.812 1.022 1.562v8.583c0 .75-.34 1.271-1.022 1.562-.68.292-1.284.174-1.812-.353z",
    fill: "#606060"
  })));
}

export default SvgIconLeftRoundedArrow;